// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
import * as popper from "@popperjs/core";
import { Tooltip, Tab, Modal } from "bootstrap";
import "./controllers";

document.addEventListener("turbo:load", () => {
  const bootstrapTooltips = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  bootstrapTooltips.forEach((tooltip) => Tooltip.getOrCreateInstance(tooltip));

  const bootstrapTabs = document.querySelectorAll('[data-bs-toggle="tab"]');
  bootstrapTabs.forEach((tab) => Tab.getOrCreateInstance(tab));

  const bootstrapModals = document.querySelectorAll('[data-bs-toggle="modal"]');
  bootstrapModals.forEach((modal) => Modal.getOrCreateInstance(modal));
});
